import * as utils from '../support/utils';

export default {
    name: "SvgIcon",

    props: {
        name: {
            type: String,
            required: true
        },
        classes: {
            type: String
        }
    },

    data: () => ({
        icon: null
    }),

    created() {
        utils.svgIcon(this.name, this.classes, icon => {
            this.icon = icon;
        });
    },

    render(createElement) {
        return createElement(this.icon ? this.icon.tagName : 'i', {
            class: this.icon ? this.icon.getAttribute('class') : `icon ${this.name} ${this.classes}`,
            domProps: {
                innerHTML: this.icon ? this.icon.innerHTML : ''
            }
        });
    }
}
